<template>
    <div>
        <div class="bg-white" v-if="web_view == true">
            <b-container>
                <div v-if="selected_report.logo_path!=null" class="position-absolute" style="padding-top: 50px"><b-img :src="$store.state.static_host+selected_report.logo_path" class="report-logo-regular"></b-img></div>
                <div class="float-right d-flex" style="padding-top: 50px" >
                    <b-button variant="dark-border" class="py-1 mb-3 mr-1 f-140 d-flex align-items-center" v-print="'#full-report-preview'"><div class="f-100 d-inline">Print</div></b-button> 
                    <b-button variant="dark-border" class="py-1 mb-3 f-140 d-flex align-items-center" @click="toggleLang"><div class="f-100 d-inline">{{lang!='ENG'?'ENG':'KOR'}}</div></b-button> 
                </div>
                <h2 class="mb-4" style="padding-top: calc(40vh - 120px)">{{ lang!='ENG'? selected_report.report_name: selected_report.report_name_e }}</h2>
                <div class="">{{ selected_report.start_date }} ~ {{ selected_report.end_date }}</div>
            </b-container>
        </div>
        <div v-else>
            <div class="bg-white" style="height:40vh">
                <b-container class="px-5 h-100 position-relative" >
                    <div v-if="selected_report.logo_path!=null" class="position-absolute" style="padding-top: 50px"><b-img :src="$store.state.static_host+selected_report.logo_path" class="report-logo-regular"></b-img></div>
                    <h2 class="mb-4" style="padding-top: calc(40vh - 120px)">{{ lang!='ENG'? selected_report.report_name : selected_report.report_name_e}}</h2>
                    <div class="">{{ selected_report.start_date }} ~ {{ selected_report.end_date }}</div>
                </b-container>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import ContentsListBasic from './ContentsListBasic.vue'
import * as ih from '@/components/util'

export default {
    components:{
        ContentsListBasic
    },
    data() {
        return {
            show_data_table: {},
            show_business_case: {},
            low_height: false,
        }
    },    
    props:{
        web_view: {type: Boolean, default: false}
    },
    computed:{
        ...mapState(['backend_host']),
        ...mapState('report_list', ['report_code', 'lang', 'view_mode']),
        ...mapState('gri2021_report_view', ['report_structure', 'report_contents_loaded']),
        ...mapGetters('gri2021_report_view', ['report_topics', 'report_categories', 'report_topic_specific_categories', 'report_universal_categories', 'report_topic_types']),
        ...mapGetters('report_list', ['selected_report']),
        main_color(){
            return this.selected_report.main_color
        }
    },
    methods: {
        ...mapMutations('report_list', ['change_lang']),
        ...mapActions('gri2021_report_view', ['readReportContents']),
        toggleLang(){
            if (this.lang=='KOR'){ //현재 국문이면 영문으로 바꾸기
                this.change_lang('ENG')
            }else this.change_lang('KOR')
        }
    },
    created(){

    }
}


</script>